'use strict'

const isInBounds = (bounds, x, y) => x > bounds.x && x < bounds.x + bounds.width && y > bounds.y && y < bounds.y + bounds.height

module.exports = {
    isInBounds
}